import "./App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import ReactGA from "react-ga4";
import Header from "./components/Header";
import Footer from "./components/Footer";
import { Toaster } from "./components/ui/sonner";
import Home from "./pages/Home";
import SubmitIdea from "./pages/SubmitIdea";
import KnowledgeCenter from "./pages/KnowledgeCenter";
import PreviousEditions from "./pages/PreviousEditions";
import Content from "./pages/Content";
import Alumni from "./pages/Alumni";
import Help from "./pages/Help";
import AIXPlatform from "./pages/AIX";
import AIXApplications from "./pages/AIXApplications";
import Login from "./pages/auth/Login";
import SignUp from "./pages/auth/Signup";
import OldSubmit from "./pages/oldsubmit";
import UdbhavCase from "./pages/udbhavCase";
import Udbhav1Awards from "./pages/udbhavawards";
import FinalAwards from "./pages/FinalAwards"
import ChairmanAwards from "./pages/ChairmanAwards"
// import ParticipationAwards from "/pages/ParticipationAwards"

import   OldEmailSubmit  from    "./pages/oldemailsubmit"
import SubmissionInsights from "./pages/SubmissionInsights";
import Article from "./pages/Artical";
import ShortlistedTeams from "./pages/ShortlistedTeams";
import Finalists from "./pages/Finalists";



// Initialize Google Analytics
ReactGA.initialize("G-PXVJ80G720");

function Layout() {
  const location = useLocation();

  // Track page views
  useEffect(() => {
    ReactGA.send({ hitType: "pageview", page: location.pathname });
  }, [location.pathname]);

  // Check if current path is "/aix-applications"
  const hideLayout = location.pathname === "/aix-applications";

  return (
    <>
      {!hideLayout && <Header />}
      <Toaster position="top-right" />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/submit-idea" element={<SubmitIdea />} />
        <Route path="/login" element={<Login />} />
        <Route path="/oldsubmit" element={<OldSubmit />} />
        <Route path="/signup" element={<SignUp />} />
        <Route path="/knowledge-center" element={<KnowledgeCenter />} />
        <Route path="/previous-editions" element={<PreviousEditions />} />
        <Route path="/content" element={<Content />} />
        <Route path="/alumni" element={<Alumni />} />
        <Route path="/udbhav-case" element={<UdbhavCase />} />
        <Route path="/awards" element={<Udbhav1Awards />} />
        <Route path="/old-email-submit" element={<OldEmailSubmit />} />
        {/* <Route path="/participation-awards" element={<ParticipationAwards />} /> */}
        <Route path="/final-awards" element={<FinalAwards />} />
        <Route path="/chairman-awards" element={<ChairmanAwards />} />
        <Route path="/udbhav-awards" element={<Udbhav1Awards />} />
        <Route path="/aix-platform" element={<AIXPlatform />} />
        <Route path="/aix-applications" element={<AIXApplications />} />
        <Route path="/help" element={<Help />} />
        <Route path="/submission-insights" element={<SubmissionInsights />} />
        <Route path="/article" element={<Article />} />
        <Route path="/shortlisted" element={<ShortlistedTeams />} />
        <Route path="/finalists" element={<Finalists />} />
      </Routes>
      {!hideLayout && <Footer />}
    </>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Layout />
      </BrowserRouter>
    </div>
  );
}

export default App;